import {
  CoreApi,
  InteriorComponent,
  OrganizerComponent,
  ProductType
} from '@inter-ikea-storageone/range';
import { ComponentIds, Entity, HierarchyUtils } from '@inter-ikea-core/core';
import { PlacementResult } from '@inter-ikea-core/core';
import { getMajorityProduct } from './frontLayouts';

const resnapDescendantEntitiesAfterDissolve = (
  placementResult: PlacementResult[],
  coreApi: CoreApi
) => {
  const placedEntites = placementResult
    .map(result => result.placedEntity)
    .filter(Boolean) as Entity[];

  const entitiesToResnap = placedEntites
    .flatMap(entity => HierarchyUtils.descendants(entity))
    .filter(
      entity =>
        !entity.hasComponent(ComponentIds.PROPPING_COMPONENT_ID) &&
        !entity.hasComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID)
    );
  entitiesToResnap.forEach(entity => coreApi.entities.resnapEntity(entity));
};

export const addInteriorSuggestionEntityToFrame = (
  interiorSuggestionEntity: Entity,
  frameEntity: Entity,
  coreApi: CoreApi,
  interiorsToIgnore?: Entity[]
) => {
  const frame = frameEntity.hasComponent(ComponentIds.ASSEMBLY_STRUCTURE_COMPONENT_ID)
    ? HierarchyUtils.children(frameEntity)[0]
    : frameEntity;
  const handlesOnFrame = coreApi.entities.getDescendantsWithComponent(
    frame,
    ComponentIds.HANDLE_COMPONENT_ID
  );
  const handlesInScene = coreApi.entities.getByComponent(ComponentIds.HANDLE_COMPONENT_ID);
  const handleToAdd =
    handlesOnFrame.length > 0
      ? getMajorityProduct(handlesOnFrame)
      : getMajorityProduct(handlesInScene);

  const interiorsInFrame = HierarchyUtils.children(frame).filter(
    child => child.hasComponent(OrganizerComponent.id) || child.hasComponent(InteriorComponent.id)
  );

  const filteredInteriorsInFrame =
    interiorsToIgnore && interiorsToIgnore.length > 0
      ? interiorsInFrame.filter(i => !interiorsToIgnore.some(j => j.id === i.id))
      : interiorsInFrame;

  coreApi.entities.deleteMultiple(filteredInteriorsInFrame);

  const placementResult = coreApi.placementService.snapToTarget(interiorSuggestionEntity, frame);
  if (placementResult?.placedEntity) {
    const result = coreApi.placementService.dissolveEntity(placementResult.placedEntity);

    // When dissolving the interior suggestion only the first hierarchy of interiors are resnapped correctly to the frame.
    // Therefore we need to resnap entities further down in the hiearchy of the interior suggestion (e.g. interiors inside divider)
    resnapDescendantEntitiesAfterDissolve(result, coreApi);

    const drawersInFrame = HierarchyUtils.descendants(frame).filter(entity =>
      coreApi.entities.isProductType(entity, ProductType.PLATSA_DRAWER_ASM)
    );
    drawersInFrame.forEach(drawer => {
      if (handleToAdd) {
        coreApi.products.addToTarget(handleToAdd, drawer);
      }
    });
  }
  return placementResult;
};
